import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
import _imports_0 from '../../../assets/audioGuide/see.png';
import _imports_1 from '../../../assets/audioGuide/audio-bg.png';
import _imports_2 from '../../../assets/audioGuide/location.png';
import _imports_3 from '../../../assets/audioGuide/r_location.png';
const _hoisted_1 = {
  class: "exhibition-container"
};
const _hoisted_2 = {
  class: "exhibition-img"
};
const _hoisted_3 = {
  class: "swiper swiper-container",
  ref: "swiperNav"
};
const _hoisted_4 = {
  class: "swiper-wrapper"
};
const _hoisted_5 = {
  class: "swiper-image swiper-slide"
};
const _hoisted_6 = ["onClick", "src"];
const _hoisted_7 = {
  key: 0,
  class: "viewNum"
};
const _hoisted_8 = {
  class: "audio"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "slider"
};
const _hoisted_11 = {
  class: "nowTime"
};
const _hoisted_12 = {
  key: 1,
  class: "changeLanguage"
};
const _hoisted_13 = {
  class: "exhibition-box"
};
const _hoisted_14 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin-bottom": "0.10rem"
  }
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  style: {
    "display": "flex",
    "border-bottom": "solid 1px #d6d6d6"
  }
};
const _hoisted_17 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center"
  },
  class: "type"
};
const _hoisted_18 = {
  key: 0,
  class: "image-icon",
  src: _imports_2
};
const _hoisted_19 = {
  key: 1,
  class: "image-icon",
  src: _imports_3
};
const _hoisted_20 = {
  class: "exhibition-address"
};
const _hoisted_21 = {
  style: {
    "margin-top": "0.20rem"
  }
};
const _hoisted_22 = ["innerHTML"];
const _hoisted_23 = ["src"];
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "recommend"
};
const _hoisted_26 = {
  class: "recommend-title"
};
const _hoisted_27 = {
  class: "titleWarp"
};
const _hoisted_28 = {
  class: "recom-title"
};
const _hoisted_29 = {
  class: "recommendList"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "name"
};
const _hoisted_33 = ["innerHTML"];
const _hoisted_34 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_slider = _resolveComponent("van-slider");
  const _component_guideBottom = _resolveComponent("guideBottom");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioDetail ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudio' : ''}`),
    onTouchstart: _cache[12] || (_cache[12] = (...args) => $options.touchstart && $options.touchstart(...args))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.imgList, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("img", {
      onClick: $event => _ctx.showBigImage(item),
      src: item
    }, null, 8, _hoisted_6)]);
  }), 256))])], 512)]), $data.antiqueDetail.viewNum ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString($data.antiqueDetail.viewNum), 1), _cache[13] || (_cache[13] = _createElementVNode("img", {
    src: _imports_0
  }, null, -1))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = $event => $options.clickPlay(_ctx.index, _ctx.item)),
    class: "play"
  }, [_createElementVNode("img", {
    class: "play-icon",
    src: `${$data.isPlaying ? require(`../../../assets/audioGuide/${_ctx.$route.query.fid == 152288 ? 'w_pause' : 'pause-yellow'}.png`) : require(`../../../assets/audioGuide/${_ctx.$route.query.fid == 152288 ? 'w_play' : 'play-yellow'}.png`)}`
  }, null, 8, _hoisted_9)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($data.nowTime), 1), _createVNode(_component_van_slider, {
    "active-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    "inactive-color": _ctx.$route.query.fid == 152288 ? '#fff' : '#bca265',
    modelValue: $data.ctTime,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.ctTime = $event),
    "button-size": "10px",
    max: $data.maxValue,
    style: {
      "margin": "0 0.3rem"
    },
    disabled: !$data.hasPalyed,
    onDragStart: $options.startMove,
    onChange: $options.changeTime
  }, null, 8, ["active-color", "inactive-color", "modelValue", "max", "disabled", "onDragStart", "onChange"]), _createElementVNode("span", {
    class: _normalizeClass(`totalTime ${!$data.totalTime ? 'timaLoading' : ''}`)
  }, _toDisplayString($data.totalTime), 3)])]), _cache[14] || (_cache[14] = _createElementVNode("img", {
    src: _imports_1,
    class: "audio-bg"
  }, null, -1)), $data.antiqueDetail.en_explainObj || $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", {
    class: _normalizeClass(!_ctx.language && !$data.languageType || $data.languageType == 1 ? 'active' : ''),
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.changeLanguage(1), ["self"]))
  }, "普通话", 2), $data.antiqueDetail.fangyanleixing ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass($data.languageType == 2 ? 'active' : ''),
    onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.changeLanguage(2), ["self"]))
  }, _toDisplayString($data.antiqueDetail.fangyanleixing), 3)) : _createCommentVNode("", true), $data.antiqueDetail.en_explainObj ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(_ctx.language && !$data.languageType || $data.languageType == 3 ? 'active' : ''),
    onClick: _cache[4] || (_cache[4] = _withModifiers($event => $options.changeLanguage(3), ["self"]))
  }, "English", 2)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.language ? $data.antiqueDetail.en_explainObj : $data.antiqueDetail.explainObj), 1)]), _createElementVNode("div", _hoisted_16, [$data.location ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_ctx.$route.query.fid != 152288 && !$data.hasChangeLanguage ? (_openBlock(), _createElementBlock("img", _hoisted_18)) : _createCommentVNode("", true), _ctx.$route.query.fid == 152288 && !$data.hasChangeLanguage ? (_openBlock(), _createElementBlock("img", _hoisted_19)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, _toDisplayString(!$data.hasChangeLanguage ? $data.location : ''), 1)])) : _createCommentVNode("", true), $data.antiqueDetail.likeNum || $data.antiqueDetail.likeNum === '0' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(`likeNum ${$data.isLiked ? 'likedNum' : ''}`),
    onClick: _cache[5] || (_cache[5] = $event => $options.editFormData(2))
  }, _toDisplayString($data.antiqueDetail.likeNum), 3)) : _createCommentVNode("", true), $data.antiqueDetail.zhishituozhan && !_ctx.language ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "linkUrl",
    onClick: _cache[6] || (_cache[6] = _withModifiers($event => $options.openUrl($data.antiqueDetail.zhishituozhan), ["stop"]))
  }, "知识拓展")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("p", {
    class: _normalizeClass(`exhibition-content ${$data.isFolded ? 'hide' : ''}`),
    innerHTML: $data.antiqueDetail.description
  }, null, 10, _hoisted_22), _createElementVNode("div", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.toggleFold && $options.toggleFold(...args)),
    class: _normalizeClass(`state ${$data.isFolded ? 'nofold' : 'fold'}`)
  }, [_createElementVNode("span", null, _toDisplayString($data.isFolded ? `${this.language ? 'all' : '全部介绍'}` : `${this.language ? 'up' : '收起'}`), 1), _createElementVNode("img", {
    class: "richarrow",
    src: `${$data.isFolded ? require('../../../assets/audioGuide/arrow-down.png') : require('../../../assets/audioGuide/arrow-up.png')}`
  }, null, 8, _hoisted_23)], 2)])]), $data.audioPath ? (_openBlock(), _createElementBlock("audio", {
    key: 2,
    ref: "audioItem",
    id: "audio",
    preload: "auto",
    onCanplay: _cache[8] || (_cache[8] = $event => $options.getDuration('audioItem')),
    onTimeupdate: _cache[9] || (_cache[9] = (...args) => $options.handleAudioTimeUpdate && $options.handleAudioTimeUpdate(...args)),
    onLoadedmetadata: _cache[10] || (_cache[10] = (...args) => _ctx.onLoadedmeta && _ctx.onLoadedmeta(...args))
  }, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_24)], 544)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("span", {
    style: _normalizeStyle(`${_ctx.$route.query.fid != 152288 ? 'color:#c9b670;' : 'color:#9D0909;'}font-size:0.5rem;display: inline-block;vertical-align: middle;`)
  }, "|", 4), _createElementVNode("span", _hoisted_28, _toDisplayString(this.language ? 'recommend' : '推荐'), 1)]), _createElementVNode("div", {
    onClick: _cache[11] || (_cache[11] = (...args) => $options.replace && $options.replace(...args)),
    class: "replace"
  }, _toDisplayString(this.language ? 'change' : '换一换'), 1)]), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.recommendList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "recommendItem",
      onClick: $event => $options.toDetail(item)
    }, [_createElementVNode("img", {
      src: item.littleImage
    }, null, 8, _hoisted_31), _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.language ? item.en_explainObj : item.explainObj), 1), !_ctx.language ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "duration",
      innerHTML: item.introduction
    }, null, 8, _hoisted_33)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "duration",
      innerHTML: item.en_introduction
    }, null, 8, _hoisted_34))], 8, _hoisted_30);
  }), 256))])]), _ctx.$route.query.fid == 152288 ? (_openBlock(), _createBlock(_component_guideBottom, {
    key: 0
  })) : _createCommentVNode("", true)], 34);
}